import { Collapse } from 'antd';
import * as React from 'react';

interface SingleCollapseProps {
  children: React.ReactNode,
  header: React.ReactNode | string,
  className?: string;
  onChange?: (open: boolean) => void
}

const SingleCollapse = ({ children, header, className, onChange }: SingleCollapseProps) => {

  function handleOnChange(key: string[]) {
    if (!onChange) {
      return;
    }
    if (key.includes('1')) {
      onChange(true);
    } else {
      onChange(false);
    }
  }

  return (
    <Collapse onChange={handleOnChange} ghost style={{ padding: 0 }} items={[{
      key: '1',
      label: header,
      children,
      classNames: {
        header: className,
        body: ''
      },
      styles: {
        header: {
          padding: 0
        },
        body: {
          padding: 0
        }
      }
    }]}
              expandIconPosition={'end'}
    >
    </Collapse>);
};
export default SingleCollapse;
